export default function () {
  return {
    current: {
      id: '',
      name: '',
      intervalUnit: 'Days',
      intervalValue: 0,
      alarmAfter: 0,
      systems: []
    },
    update: {
      id: '',
      name: '',
      intervalUnit: 'Days',
      intervalValue: 0,
      alarmAfter: 0
    },
    list: [],
    intervals: [
      'Days',
      'Weeks',
      'Months'
    ]
  }
}
